import { render } from "./active.vue?vue&type=template&id=63af0ea0&scoped=true"
import script from "./active.vue?vue&type=script&lang=js"
export * from "./active.vue?vue&type=script&lang=js"

import "./active.vue?vue&type=style&index=0&id=63af0ea0&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63af0ea0"]])

export default __exports__